import { connect } from 'react-redux';
import BlockForm from '../components/blocks/Form';
import Form from '../components/workouts/Form';
import Info from '../components/workouts/Info';
import List from '../components/workouts/List';
import Preview from '../components/workouts/Preview';
import withAuth from '../hocs/withAuth';
import { fetchBlock, resetBlock, fetchMoreBlock } from '../store/actions/blocks';
import {
  createWorkout,
  fetchFormValues,
  fetchBlockFormValues,
  fetchInfo,
  fetchList,
  patchWorkout,
  updateDuration,
  updateWorkoutImg,
  resetWorkouts,
  resetWorkoutInfo,
  fetchMoreWorkouts,
	updateOrder
} from '../store/actions/workouts';

import {
	fetchMoreExercise,
	toggleExerciseFavourite,
	resetExercisesListing,
	setExerciseFilter,
	setExerciseSearchTerm,
	resetExerciseFilter
  } from '../store/actions/exercises';

function mapStateToProps(state, ownProps) {
	var editId = null;
	if (ownProps.match) editId = ownProps.match.params.id;
	if (ownProps.editId) editId = ownProps.editId;
	if (ownProps.workoutId) editId = ownProps.workoutId;
	return {
		errors: state.errors,
		user: state.currentUser.user,
		workoutCats: state.workoutCats,
		blockCats: state.blockCats,
		workouts: state.workouts.data,
		isLoadMoreListing: state.workouts.isLoadMore,
		products: state.products,
		exerciseCats: state.exerciseCats,
		equipment: state.equipment,
		trainerExercises: state.exercises.trainer,
		corporateExercises: state.exercises.corporate,
		favExercises: state.exercises.favourite,
		filter: state.exercises.filter,
		isLoadMoreLibraryExercises: state.exercises.isLoadMore,
		searchTerm: state.exercises.searchTerm,
		blocks: state.blocks.data,
		isLoadMoreLibraryBlocks: state.blocks.isLoadMore,
		workoutInfo: state.workouts.info,
		blockInfo: state.blocks.info,
		editId: editId,
		...ownProps,
	};
}
const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		fetchBlock: blockId => {
			return dispatch(fetchBlock(blockId));
		},
		fetchInfo: () => {
			var id = null;

			if (ownProps.match) id = ownProps.match.params.id;
			if (ownProps.workoutId) id = ownProps.workoutId;
			if (id) {
				return dispatch(fetchInfo(id));
			} else {
				console.warn('No id supplied in url.');
				return false;
			}
		},
		fetchListData: (query) => {
			return dispatch(fetchList(query));
		},
		fetch: (userId, editId) => {
			return dispatch(fetchFormValues(userId || localStorage.id, editId));
		},
		fetchBlockFormValues: (userId, editId) => {
			return dispatch(fetchBlockFormValues(userId || localStorage.id, editId));
		},
		fetchMoreExercise: (query) => {
			return dispatch(fetchMoreExercise(query));
		},
		resetWorkouts: () => {
			return dispatch(resetWorkouts()); 
		},
		resetWorkoutInfo: () => {
			return dispatch(resetWorkoutInfo()); 
		},
		fetchMoreWorkouts: (query) => {
			return dispatch(fetchMoreWorkouts(query));
		},
		fetchMoreBlock: (query) => {
			return dispatch(fetchMoreBlock(query));
		},
		resetExercises: () => {
			return dispatch(resetExercisesListing());
		},
		resetExerciseFilter: () => {
			return dispatch(resetExerciseFilter());
		},
		resetBlocks: () => {
			return dispatch(resetBlock());
		},
		setExerciseFilter: (filter) => {
			return dispatch(setExerciseFilter(filter));
		},
		setExerciseSearchTerm: (term) => {
			return dispatch(setExerciseSearchTerm(term));
		},
		updateOrder: (reqOrders, items) => {
			return dispatch(updateOrder(reqOrders, items));
		},
		create: (type, parentData, childData) => {
			let userType = ownProps.user.type;
			if (userType && userType.includes('trainer')) {
				userType = 'trainer';
			}
			if (userType && userType.includes('brand')) {
				userType = 'brand';
			}
			if (userType && userType.includes('corporate')) {
				userType = 'corporate';
			}

			return dispatch(
				createWorkout(
					type,
					{
						...parentData,
						creatorId: ownProps.user._id,
						creatorType: userType,
					},
					childData
				)
			);
		},
		edit: (type, parentData, childData) => {
			return dispatch(patchWorkout(type, parentData, childData));
		},
		updateDuration: (workoutId, type) => {
			return dispatch(updateDuration(workoutId, type));
		},
		toggleExerciseFavourite: (param) => {
			return dispatch(toggleExerciseFavourite(param));
		},
		updateWorkoutImg: (workoutId, imgUrl) => {
			return dispatch(updateWorkoutImg(workoutId, imgUrl));
		},
	};
};
export const CreateBlock = withAuth(
	connect(mapStateToProps, mapDispatchToProps)(BlockForm)
);
export const EditBlock = withAuth(
	connect(mapStateToProps, mapDispatchToProps)(BlockForm)
);
export const CreateWorkout = withAuth(
	connect(mapStateToProps, mapDispatchToProps)(Form)
);
export const EditWorkout = withAuth(
	connect(mapStateToProps, mapDispatchToProps)(Form)
);
export const MyWorkouts = withAuth(
	connect(mapStateToProps, mapDispatchToProps)(List)
);
export const WorkoutInfo = withAuth(
	connect(mapStateToProps, mapDispatchToProps)(Info)
);
export const PreviewWorkoutInfo = withAuth(
	connect(mapStateToProps, mapDispatchToProps)(Preview)
);



// WEBPACK FOOTER //
// ./src/containers/Workouts.js